import io from "socket.io-client";

export default function runNetworkPingUnifiedSocket(){
    return new Promise((resolve, reject) => {
        try{
          const socket = io(process.env.UNIFIED_SOCKET, {secure: true, 'connect timeout': 2000, timeout: 2000, transports: ['websocket']})
          
          const handleOnConnection = () => {
            socket.disconnect()
            resolve("Socket connection successful.")
          }

          socket.on("connect", handleOnConnection );
          
        }catch(err){
          console.error("Error while testing unify socket", err)
          reject(err)
        }
      })
}